import React from 'react';

import {  Divider, Popconfirm, message, Table, Icon} from 'antd';

import { httpGet, httpDelete} from '../../http';
import AddForm from './addForm';

import './medicine.css';

export default class Medicine extends React.Component {
  state = {
    modalVisibleAdd: false,
    modalTitleAdd: "",
    editValues: {},
    data: []
  }

  handleModalVisibleAdd = (flag, title, record) => {
    this.setState({
      modalVisibleAdd: !!flag,
      modalTitleAdd: title,
      editValues: record || {},
    });

  };
  
  getMedicineList = () => {
    httpGet("/api/v1/medicine/get_all_medicines")
    .then(res => {
      return res.json();
    })
    .then(data => {
      this.setState({
        data: data.data,
      })
    })
    .catch(err => {
      message.error('Interface error: get_medicine_list');
    }
    )
  }
  delete_confirm = (id) => {
    httpDelete("/api/v1/medicine/delete_medicine", JSON.stringify({ id: id }))
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.code === 0) {
          message.info('Delete Success!');
          this.getMedicineList();
        }
      })
      .catch(err => {
        message.error('Interface error:delete_medicine');
      }
      )
  };
  componentDidMount() {
    this.getMedicineList()
  }

  componentWillUnmount() {
  }

  columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      align: 'center'
    },
    {
      title: "Medicine",
      dataIndex: "medicine",
      key: "medicine",
      align: 'center'
    },
    {
      title: "Alert Num",
      dataIndex: "alert_num",
      key: "alert_num",
      align: 'center'
    },
    {
      title: "Store Num",
      dataIndex: "store_num",
      key: "store_num",
      align: 'center'
    },
    {
      title: "Default Order Num",
      dataIndex: "default_order_num",
      key: "default_order_num",
      align: 'center'
    },
    {
      title: "Supplier",
      dataIndex: "supplier_name",
      key: "supplier_name",
      align: 'center'
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      align: 'center'
    }, 
    {
      title: <Icon type="plus-circle" style={{ fontSize: 22, cursor: 'pointer' }}
        onClick={() => this.handleModalVisibleAdd(true, 'Add Medicine', {})}
      />,
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <span>
          <Icon type="edit" onClick={() => this.handleModalVisibleAdd(true, 'Edit Medicine', record)}/> 
          <Divider type="vertical" /> 
          <Popconfirm placement="top" title="Are you sure you want to delete this medicine?"
            onConfirm={() => this.delete_confirm(record.id)} okText="Yes" cancelText="No" >
            <a href="#!;"><Icon type="delete" style={{ fontSize: 16, color: 'red' }} /></a>
          </Popconfirm>
        </span>
      ),
    },
  ]
  render() {
    const parentMethodsAdd = {
      handleModalVisibleAdd: this.handleModalVisibleAdd,
      getMedicineList: this.getMedicineList
    };
   
    return (
      <div className='medicine'>
        <Table
            rowKey={(record, index) => index}
            columns={this.columns}
            dataSource={this.state.data}
          />
        <AddForm {...parentMethodsAdd} modalVisibleAdd={this.state.modalVisibleAdd} modalTitleAdd={this.state.modalTitleAdd} initData={this.state.editValues} />
      </div>
    );
  };
 
};
